import TenantUserPage from '../hocs/TenantUserPage';

export default TenantUserPage(function Login(props) {
  const { history, location, match: { params: { tenantPath } } } = props;
  const { state: { referrer } = {} } = location;
  history.replace(referrer || `/${tenantPath}/events`);
  return null;
});
